import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';

import { SharedLanguageService } from '@language';
import { MakeProvider, ShDynamicDialogService } from '@stylehaven/components';
import { FormWebserviceComplexBaseComponent } from '../base-complex/form-webservice-base-complex.component';

@Component({
    standalone: false,
    selector: 'med-form-webservice-base',
    templateUrl: '../base-complex/form-webservice-base-complex.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [MakeProvider(FormWebserviceBaseComponent)]
})
export class FormWebserviceBaseComponent extends FormWebserviceComplexBaseComponent {
    constructor(
        changeDetectorRef: ChangeDetectorRef,
        translateService: SharedLanguageService,
        dialogService: ShDynamicDialogService
    ) {
        super(changeDetectorRef, translateService, dialogService);
    }
}
